<template>
  <div
    data-component="spa-soft-footer"
    class="spa-soft-footer"
    :class="{
      '--fixed': footerIsFixed,
      '--hidden': footerIsHidden,
    }"
  >
    <div
      class="spa-soft-footer-wrapper container"
    >
      <div
        class="spa-soft-footer-continue"
      >
        <button
          v-if="nextStepLabel"
          :disabled="hasGuestsWithNoSelectedTreatments"
          class="button--primary black size-md primary"
          :class="[{ loading: isSpaLoading }, nextStepClass]"
          @click="handleClick"
        >
          <div
            class="sr-only"
            role="status"
          >
            {{ isSpaLoading ? tc('accessibility.loadingButtonStatus') : '' }}
          </div>
          {{ nextStepLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'SpaSoftFooter',
    data: () => ({}),
    computed: {
      ...mapState('spaSoft', ['step', 'ready', 'nextStepIndex', 'nextStepLabel', 'nextStepClass', 'isSpaLoading', 'selectedItineraryTrackingData']),
      ...mapGetters('spaSoft', ['hasItinerarySelected', 'hasGuestsWithNoSelectedTreatments']),
      ...mapGetters('i18n', ['tc']),
      footerIsFixed() {
        return this.step === 1 && this.hasItinerarySelected
      },
      footerIsHidden() {
        return this.step === 1 && !this.hasItinerarySelected || this.step === 2
      },
    },
    mounted() {

    },
    methods: {
      ...mapActions('spaSoft', ['goToStep', 'validateSpaSoftRoute']),
      async handleClick() {
        if (typeof this.nextStepIndex === 'number') {
          this.goToStep(this.nextStepIndex)
          if (this.nextStepIndex === 2) {
            this.$track(this.selectedItineraryTrackingData)
          }
        } else if (typeof this.nextStepIndex === 'string') {
          if (this.nextStepIndex === 'validate') {
            this.validateSpaSoftRoute()
          } else {
            this.$router.push({
              name: this.nextStepIndex,
              query: {
                ...this.$route.query,
              }
            })
          }
        }
      }
    },
  }
</script>
